import { createSlice } from "@reduxjs/toolkit";
import { loadLayoutData } from "./operations";

import { MenuItem } from "../layout/HeaderV2/types";

export type MenuItemType = { link: string; title: string };

type SliceState = {
  loading: boolean;
  error: null | string;
  solutions: MenuItemType[];
  headerMenuItems: MenuItem[];
};

const initialState: SliceState = {
  error: null,
  loading: false,
  solutions: [],
  headerMenuItems: [],
};

const navigationSlice = createSlice({
  name: "navigationData",
  initialState,
  reducers: {
    setNavigationData: (state, { payload }) => {
      state.solutions = payload.solutions.map((solution: any) => ({
        link: `/erps/${solution.attributes.slug}`,
        title: solution.attributes.name,
      }));
      state.headerMenuItems = payload.headerData.menuItem;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(loadLayoutData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loadLayoutData.fulfilled, (state, { payload }) => {
        state.solutions = payload.navigation.solutions.map((solution) => ({
          link: `/erps/${solution.attributes.slug}`,
          title: solution.attributes.name,
        }));
        state.headerMenuItems = payload.headerData.menuItem;
        state.loading = false;
      })
      .addCase(loadLayoutData.rejected, (state, { payload }) => {
        if (payload) {
          state.error = payload;
        }
        state.loading = false;
      });
  },
});

export const { reducer, actions } = navigationSlice;
